import {makeStyles, withStyles} from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";

export const CustomTable = withStyles({
    root: {
        minWidth: "650px",
        '& .MuiTableCell-head': {
            backgroundColor: "transparent !important"
        },
        '& .MuiTableRow-root': {
            '& .MuiTypography-root': {
                cursor: "text"
            },
            cursor: "default"
        }
    },
})(Table);

export const useTokenOptionsTableStyles = makeStyles({
    contentCell: {
        verticalAlign: "top"
    },
    modificaStatoButton: {
        marginTop: "1em"
    }
});
